<div class="info-box mt-3 mb-3 bg-danger">
    <span class="info-box-icon"><i class="fas fa-exclamation-triangle"></i></span>
    <div class="info-box-content">
        <span class="h4 info-box-text mb-0">BLOQUE DESCONOCIDO</span>
        <span class="info-box-text">La plantilla presenta problemas para visualizar este bloque</span>
    </div>
</div>